import config from 'message-control/config'

const ewechatMsgApi = `${config.apiHost}/oem-ewechat_msg`

export default {
    info: {
        url: `${ewechatMsgApi}/api/config`,
        type: 'GET',
    },
    update: {
        url: `${ewechatMsgApi}/api/config`,
        type: 'POST',
    },
    publicKey: {
        url: `${ewechatMsgApi}/api/rsa/public_key`,
        type: 'GET',
    },
    regeneratePublicKey: {
        url: `${ewechatMsgApi}/api/rsa/regenerate`,
        type: 'PUT',
    },
    publicKeyVersion: {
        url: `${ewechatMsgApi}/api/rsa/version`,
        type: 'GET',
    },
    updatePublicKeyVersion: {
        url: `${ewechatMsgApi}/api/rsa/version`,
        type: 'POST',
    },
    getBindPhoneStatus: {
        url: `${ewechatMsgApi}/api/config/binding_cellphone`,
        type: 'GET',
    },
    setBindPhoneStatus: {
        url: `${ewechatMsgApi}/api/config/binding_cellphone`,
        type: 'PUT',
    },
}
